import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'

import { apiScoping } from '@/lib/api/scoping'
import { featureFlagKeys } from '@/features/feature-flags/api/query-keys'

// Record (not a closed object) so the API can ship flags this client doesn't
// know about yet without breaking validation for the ones it does.
export const FeatureFlagsResponseSchema = z.record(z.string(), z.boolean())

export type FeatureFlagsDto = z.infer<typeof FeatureFlagsResponseSchema>

async function fetchFeatureFlags(): Promise<FeatureFlagsDto> {
  const res = await apiScoping.get('/api/v1/features')
  const result = FeatureFlagsResponseSchema.safeParse(res.data)
  if (!result.success) {
    console.error(
      '[feature-list] Zod parse failed - raw response:',
      res.data,
      'issues:',
      result.error.issues
    )
    throw result.error
  }
  return result.data
}

// Flags are resolved per user by the API and never change mid-session:
// staleTime + gcTime Infinity mean one GET /api/v1/features per session no
// matter how many components read flags.
export function featureFlagsQueryOptions() {
  return queryOptions({
    queryKey: featureFlagKeys.all,
    queryFn: fetchFeatureFlags,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false
  })
}
